import { WORKOUT_KEY } from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { logUtil } from 'packages/src'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { getByIdWorkoutSelector } from 'modules/workout/redux/selectors'
import MediaImage from 'containers/MediaImage'
import getNameReduxUtil from 'modules/redux/utils/get-name'

export default function WorkoutMediaImage (props) {
  const {
    id,
    ...rest
  } = props
  const instance = useSelector(getByIdWorkoutSelector(id))

  const debugProps = {
    id,
    instance,
    props
  }

  logUtil('WorkoutMediaImage').debug('[start] debugProps=', debugProps)

  if (!instance) {
    logUtil('WorkoutMediaImage').debug('[noop] instance not defined')
    return <></>
  }

  return (
    <MediaImage
      id={getValueReduxUtil(instance, WORKOUT_KEY.MEDIA_ID)}
      alt={getNameReduxUtil(instance)}
      {...rest}
    />
  )
}
